import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  list: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  itemTitle: { fontWeight: 500, marginBottom: 10 },
  divider: { marginTop: 10, marginBottom: 10 },
  propertyName: { marginRight: 10 },
  modifiedItem: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  valuesList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    margin: "10px 0 0 5%",
    flexBasis: "100%",
  },
  modifiedItemWrapper: {
    display: "flex",
    flexBasis: "100%",
    marginLeft: "3.2%",
    marginTop: 10,
    overflow: "hidden",
  },
});
